import React from "react";
import { FormControl, InputLabel, MenuItem, Select, useTheme } from "@mui/material";
import { useDarkMode } from "../../../../../hooks/useDarkMode";
import { SpaceOption } from "../../types";

interface SpaceSelectorProps {
  value: string;
  onChange: (value: string) => void;
  spaces: SpaceOption[];
  disabled?: boolean;
  required?: boolean;
}

export const SpaceSelector: React.FC<SpaceSelectorProps> = ({
  value,
  onChange,
  spaces,
  disabled = false,
  required = false,
}) => {
  const theme = useTheme();
  const { customColorPalette: palette } = theme;
  const isDarkMode = useDarkMode();

  return (
    <FormControl fullWidth required={required}>
      <InputLabel>Select Space</InputLabel>
      <Select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        label="Select Space"
        disabled={disabled}
        sx={{
          backgroundColor: isDarkMode ? palette.gray[800] : "#FFFFFF",
          color: isDarkMode ? palette.gray.A100 : palette.gray[900],
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: isDarkMode ? palette.gray[700] : palette.gray[300],
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: isDarkMode ? palette.gray[600] : palette.gray[400],
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: palette.blue[500],
          },
          "& .MuiInputLabel-root": {
            color: isDarkMode ? palette.gray[400] : palette.gray[600],
          },
          "& .MuiInputLabel-root.Mui-focused": {
            color: palette.blue[500],
          },
        }}
      >
        <MenuItem
          value="private"
          sx={{
            color: isDarkMode ? palette.gray.A100 : palette.gray[900],
            "&:hover": {
              backgroundColor: isDarkMode ? palette.gray[700] : palette.gray[100],
            },
          }}
        >
          Private
        </MenuItem>
        {spaces.map((space) => (
          <MenuItem
            key={space.id}
            value={space.id}
            sx={{
              color: isDarkMode ? palette.gray.A100 : palette.gray[900],
              "&:hover": {
                backgroundColor: isDarkMode ? palette.gray[700] : palette.gray[100],
              },
            }}
          >
            {space.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
